import { createContext } from "react";
import type { User } from "./auth";

export type AuthContextType = {
  user: User | null;
  loading: boolean;
  loginUser: (u: string, p: string) => Promise<boolean>;
  logoutUser: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | null>(null);
